// extracted by css-extract-rspack-plugin
export default {"separator":"separator-KeAf8r"};